<template>
  <div class="d-inline-block">
    <v-btn icon @click="openDialog" v-if="!$vuetify.breakpoint.mobile"><v-icon>mdi-file-delimited</v-icon></v-btn>

    <v-dialog v-model="showExport" persistent max-width="350" eager scrollable>
      <v-card>
        <v-card-title class="text-h6 primary white--text">Columns to export to CSV</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4" >
          <v-list dense ref="columns" xxheight="350">
            <template v-for="column of columnsToExport">
              <v-list-item :key="column.value" class="draggable">
                <v-list-item-icon>
                  <v-icon class="handle">mdi-drag</v-icon>
                  <v-simple-checkbox v-model="column.include"/>
                </v-list-item-icon>
                <v-list-item-title>{{column.heading}}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain color="primary" @click="showExport = false">Cancel</v-btn>
          <v-btn color="primary" @click="doExport">Export</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fileSaver from 'file-saver';

export default {
  name: 'ExportList',
	props: {
    table: {type:Object,required:false},
    columns: {type:Array,required:true},
    headers: {type:Array,required:true},
    list: {type:Array,required:true},
    fileName: {type:String,required:true}
  },
  data() {
    return {
      showExport: false,
      columnsToExport: []
    }
  },
  created() {
    this.columnsToExport = this.columns.filter(column => !column.excludeFromExport).map(column => (
      {value:column.value,heading:this.headers.find(header => header.value === column.value).text,include:true}
    ));
  },
  methods: {
    openDialog() {
      setTimeout(() => this.showExport = true);
    },
    doExport() {
      // Header
      let csv = '';
      for (const column of this.columnsToExport) {
        if (column.include)
          csv += `${csv===''?'':','}"${column.heading}"`;
      }
      csv += '\r\n';

      // Each line
      for (const line of this.list) {
        let lineCSV = '';
        for (const column of this.columnsToExport) {
          if (column.include) {
            let value = line;
            column.value.split('.').forEach(key => value = value[key]);

            // If line doesn't have column named, look for a slot as it's a calculated value
            if (value === undefined && this.table) {
              const slot = this.table.$scopedSlots['item.'+column.value];
              if (slot)
                value = slot({item:line,value,csv:true})[0].text;
            }

            lineCSV += `${lineCSV===''?'':','}"${value}"`;
          }
        }
        csv += `${lineCSV}\r\n`;
      }

      // Write CSV file
      const blob = new Blob([csv], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, this.fileName);
      this.showExport = false;
    }
  }
}
</script>